import { Button, Col, Container, Modal, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { makeData } from 'utils/makeData'
import BaseModal from './BaseModal'
import demoSlider from 'assets/images/demo-slider.svg'
import friendStatus from 'assets/images/invite-friend-status.svg'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'
import { useMemo, useState, useEffect, useContext } from 'react'
import { useQuery } from 'react-query'
import { getListFriendInvitePlayGameQuery } from 'dataLayer/game'
import noDataIcon from 'assets/images/profilepage-gifthist-nodata.svg'
import { SocketContext } from 'utils/socket'
import { useNavigate } from 'react-router-dom'
import avaDefault from 'assets/images/ava-default.jpeg'

function InviteFriendModal({ show, onHide, roomId, ...otherProps }) {
	const { t } = useTranslation()
	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)
	const [listEnableSendInvite, setListEnableSendInvite] = useState({})
	const { socket, setSocketRoomId } = useContext(SocketContext)
	// const friendList = makeData('friend', 11)
	const limit = 50
	const [pageIndex, setPageIndex] = useState(0)

	const { data, isLoading } = useQuery(
		getListFriendInvitePlayGameQuery(pageIndex * limit, limit),
	)
	let friendList = (data && data?.friends) || []
	// TODO: Custom scrollbar friend list
	const setTmEnableSendInvite = id => {
		setTimeout(() => {
			const listEnableSendInviteReset = { ...listEnableSendInvite }
			listEnableSendInviteReset[id] = 0
			setListEnableSendInvite(listEnableSendInviteReset)
		}, 4000)
	}
	useEffect(() => {
		socket.on('send invite success', data => {
			const listEnableSendInviteNew = { ...listEnableSendInvite }
			listEnableSendInviteNew[data.user_invitee_id] = 1

			setListEnableSendInvite(listEnableSendInviteNew)
			setTmEnableSendInvite(data.user_invitee_id)
		})
	}, [socket])
	const onPressInviteUser = item => {
		if (item.status && !item.room_id && socket && socket.connected) {
			socket.emit('send invite', { room_id: roomId, user_id: item.id })
		}
	}

	return (
		<BaseModal show={show} onHide={onHide} {...otherProps}>
			<Container fluid className="invite-modal">
				<Modal.Header className="p-0 p-sm-3">
					<Modal.Title
						id="contained-modal-title-vcenter"
						style={isMobileMD ? { fontSize: 20, lineHeight: '24px' } : null}
					>
						{t('modal.invite.friend')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="p-0 p-sm-3">
					<Container fluid className="invite-list">
						<Row className="mb-2 list-header">
							<Col xs={6}>{t('room.table.player')}</Col>
							<Col xs={4}>{t('room.tab.gold')}</Col>
							<Col xs={2} className="text-center">
								{t('modal.invite.invite')}
							</Col>
						</Row>
						{friendList.length > 0 ? (
							friendList?.map(item => {
								return (
									<Row key={item.id} className="friend">
										<Col xs={6} className="friend-info">
											<div className="friend-info__ava">
												<img
													src={item.image || avaDefault}
													alt="Friend's avatar"
												/>
												{item.status === 1 ? (
													<img src={friendStatus} alt="Friend's status" />
												) : null}
											</div>
											<p>{item.full_name}</p>
										</Col>
										<Col xs={4} className="friend-gold">
											{new Intl.NumberFormat('lo').format(item.coin)}
										</Col>
										<Col xs={2} className="friend-invite">
											<Button
												disabled={
													item.status === 0 ||
													item.room_id > 0 ||
													(listEnableSendInvite[item.id] !== undefined &&
														listEnableSendInvite[item.id])
												}
												onClick={() => onPressInviteUser(item)}
											>
												{t('modal.invite.invite')}
											</Button>
										</Col>
									</Row>
								)
							})
						) : (
							<img
								className="img--no-data"
								src={noDataIcon}
								alt="No reward is found"
							/>
						)}
					</Container>
				</Modal.Body>
			</Container>
		</BaseModal>
	)
}

export default InviteFriendModal
